export default __webpack_public_path__ + "static/media/3.ed829d97.png";